import { render, staticRenderFns } from "./Kids.vue?vue&type=template&id=53b7a0e0&scoped=true&"
import script from "./Kids.vue?vue&type=script&lang=js&"
export * from "./Kids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b7a0e0",
  null
  
)

export default component.exports